import { ProvinceService } from "../../../../services/http/business/province/provinces.service";
import { ErrorsService } from "../../../../services/common/errors.service";
import { Component, OnInit, EventEmitter, Output } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { IProvince } from "src/app/interfaces/province";
import { ICity } from "src/app/interfaces/city";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { TranslateService } from "@ngstack/translate";
import { IRegister } from "src/app/interfaces/register";
import * as moment from "jalali-moment";
import { CityService } from "src/app/services/http/business/city/city.service";
import { ErrorStateMatcher } from "@angular/material/core";
import { SoundEnum } from "src/app/enums/sound.enum";
import { AccountService } from "src/app/services/http/business/account/account.service";
import { environment } from "src/environments/environment";
import { MatSelect } from "@angular/material";
import { MajorDegreeService } from "../../../../services/http/business/majorDegree/major-degree.service";
import { JobService } from "../../../../services/http/business/job/job.service";
import { IMajorDegree } from "../../../../interfaces/majorDegree";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-register-direct-form',
  templateUrl: './register-direct-form.component.html',
  styleUrls: ['./register-direct-form.component.css']
})
export class RegisterDirectFormComponent implements OnInit {
  @Output() register = new EventEmitter<any>();

  form: FormGroup;
  provinceList: IProvince;
  cityList: ICity;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  matcher = new ErrorStateMatcher();
  maxDate: Date;
  introductionMethodList: any;
  jobList: any;
  majorList: IMajorDegree[];
  degreeList: IMajorDegree;

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private majorService: MajorDegreeService,
    private jobService: JobService,
    private accountService: AccountService,
    private cityService: CityService,
    private provinceService: ProvinceService
  ) { }

  ngOnInit() {
    this.maxDate = new Date(new Date().setFullYear(new Date().getFullYear() - 5));
    this.form = this.fb.group(
      {
        NationalCode: [
          null,
          Validators.compose([
            Validators.required,
            Validators.pattern("^[0-9]*$"),
            Validators.minLength(10),
            Validators.maxLength(12)
          ])
        ],
        Password: [
          null,
          Validators.compose([
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(30)
          ])
        ],
        RePassword: [null, Validators.compose([Validators.required])],

        FirstName: [
          null,
          Validators.compose([
            Validators.required,
            Validators.maxLength(50),
            Validators.pattern("([\u0600-\u06FF 0-9-]+)")
          ])
        ],
        LastName: [
          null,
          Validators.compose([
            Validators.required,
            Validators.maxLength(50),
            Validators.pattern("([\u0600-\u06FF 0-9-]+)")
          ])
        ],
        FatherName: [
          null,
          Validators.compose([
            Validators.maxLength(50),
            Validators.pattern("[\u0600-\u06FF 0-9-]+")
          ])
        ],
        FirstNameEn: [
          null,
          Validators.compose([
            Validators.maxLength(50),
            Validators.pattern("([A-Za-z0-9-]+)")
          ])
        ],
        LastNameEn: [
          null,
          Validators.compose([
            Validators.maxLength(50),
            Validators.pattern("([A-Za-z0-9-]+)")
          ])
        ],

        BirthDate: [null],
        PlaceCityId: [null],
        CertificatePlaceCityId: [null],
        CellPhoneNumber: [
          null,
          Validators.compose([
            Validators.required,
            Validators.maxLength(11),
            Validators.pattern("^(09[0-9][0-9]{8})?$")
          ])
        ],
        IntroductionMethodId: [
          null,
          Validators.compose([
            Validators.required
          ])
        ],
        Email: [
          '',
          Validators.compose([
            Validators.pattern(
              "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+.[a-zA-Z]{2,5}(.[a-zA-Z]{2,5}){0,1}"
            )
          ])
        ],
        CertificateNo: [null, Validators.compose([Validators.maxLength(10)])],
        Gender: [null, Validators.compose([Validators.required])],
        ProvinceId: [null],
        HomePhone: [null],
        DegreeId: [null],
        MajorId: [null],
        JobId: [null],
        Address: [null]
      }
    );
    this.getMajor();
    this.getjob();
    this.loadProvience();
    this.loadIntroductionMethod();

  }

  generateNationalCode() {
    var date = new Date();
    var components = [
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    ];
    this.form.controls['NationalCode'].setValue('00' + components.join("").substr(2, 10))
  }

  loadIntroductionMethod() {
    this.accountService.getIntroductionMethodList().subscribe(res => {
      this.introductionMethodList = res;
    });
  }

  loadProvience() {
    this.provinceService.GetList().subscribe(res => {
      this.provinceList = res;
    });
  }


  getMajor() {
    this.majorService.list().subscribe(
      res => {
        this.degreeList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getjob() {
    this.jobService.list().subscribe(res => {
      this.jobList = res.DataList;
    })
  }

  loadMajor(element: MatSelect) {
    this.majorService.degreeList(element.value).subscribe(
      res => {
        this.majorList = res.EduMajors;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadCity(element: MatSelect) {
    this.cityService.GetList(element.value).subscribe(res => {
      this.cityList = res;
    });
  }

  resetForm() {
    this.form.reset();
  }

  submit(form: IRegister) {
    this.errors = new Array();
    form.BirthDate = moment
      .from(form.BirthDate, "en")
      .utc(true)
      .format(environment.dateFormat);
    this.accountService.registerDirect(form).subscribe(
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          3000,
          SoundEnum.beep
        );
      },
      error => {
        // this.errObject = this.errorService.getError(error);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(error);
        this.errorList = this.errorService.getErrorList(error.error);
      }
    );
  }
}
